import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DriverRes from "types/res/driver/DriverRes";
import DriverApi from "api/DriverApi";
import {
  Box,
  Button,
  createStyles,
  Divider,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { changeAccount } from "redux/actions/account";
import { useHistory } from "react-router-dom";
const Setting = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const company = useSelector((state) => state.account.driver.company);
  const email = useSelector((state) => state.account.driver.email);
  const [driverList, setDriverList] = useState<DriverRes[]>([]);
  const useStyles = makeStyles(() =>
    createStyles({
      button: {},
    })
  );
  const classes = useStyles();
  useEffect(() => {
    const apiCall = async () => {
      const result = await DriverApi.findByEmail(email);
      setDriverList(result);
    };
    apiCall();
  }, []);
  const onClickChangeAccount = (driver: DriverRes) => {
    dispatch(changeAccount({ driver }));
  };
  return (
    <Box display="flex" flexDirection="column">
      <Box margin={2}>
        <Typography>現在のログイン中企業：{company.name}</Typography>
      </Box>
      <Divider />
      <Box display="flex" flexDirection="column" margin={2}>
        <Typography variant={"subtitle1"}>所属企業一覧</Typography>
        {driverList.map((driver) => (
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            marginY={1}
          >
            <Typography>{driver.company.name}</Typography>
            <Button
              variant="contained"
              className={classes.button}
              color="secondary"
              onClick={() => onClickChangeAccount(driver)}
            >
              <Typography>切り替え</Typography>
            </Button>
          </Box>
        ))}
      </Box>
      <Box marginTop={2} display={"flex"} justifyContent={"center"}>
        <Button
          variant="contained"
          className={classes.button}
          color="default"
          onClick={() => history.push("/")}
        >
          トップページへ
        </Button>
      </Box>
    </Box>
  );
};

export default Setting;
